import { configureStore } from '@reduxjs/toolkit';

import loaderReducer from './slices/loaderSlice';
import modalReducer from './slices/modalSlice';
import earningsReducer from './slices/partners/earningsSlice';
import indicateReducer from './slices/partners/indicateSlice';
import partnersReducer from './slices/partners/partnersSlice';
import portfolioReducer from './slices/partners/portfolioSlice';
import toastReducer from './slices/toastSlice';

export const store = configureStore({
  reducer: {
    partners: partnersReducer,
    indicate: indicateReducer,
    loader: loaderReducer,
    modal: modalReducer,
    toast: toastReducer,
    portfolio: portfolioReducer,
    earnings: earningsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
